import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Waveform from './../Waveform'
import ProductLabelsList from './ProductLabelsList'
import KeysList from './KeysList'
import Cover from './ProductItem/Cover'
import ItemCheckbox from './ItemCheckbox'
import DownloadItem from './DownloadItem'
import BuyItem from './BuyItem'
import FavoriteButton from './FavoriteButton'
import filtersStore from '../../stores/filtersStore'
import history from '../common/history.js'
import MenuButton from '../menu/MenuButton'
import { ReactComponent as ProductItemPoint } from '#images/product-item-point.svg'

@inject('playlistStore', 'packsStore', 'packStore', 'authStore')
@observer
class ProductItem extends Component {
  play = (e) => {
    const { playlistStore, item } = this.props

    if (item.hasAudio) {
      e.preventDefault()
      this.props.item.cover = this.cover
      playlistStore.play(item)
      playlistStore.traversingMode = 'itemlist'
    }
  }

  redirectToProduct(_e) {
    const { item, packStore, packsStore } = this.props

    if (packStore.id && (packStore.id === item.product_id)) {
      _e.preventDefault()
      return false
    } else {
      let params = filtersStore.toParams()
      const productId = packsStore.getSeoProductId(item.product_id)
      history.push(`/product/${productId}?${params}`)
    }
  }

  toggleChecked = (e) => {
    e.stopPropagation()

    const { item, playlistStore } = this.props

    if (this.checked) {
      playlistStore.remove([item.id])
    } else {
      this.props.item.cover = this.cover
      playlistStore.add(item)
    }
  }

  get cover() {
    const { packStore, packsStore, item } = this.props

    if (packStore.id == item.product_id) {
      return packStore.cover
    } else {
      return packsStore.getCover(item.product_id)
    }
  }

  get active() {
    const { playlistStore, item } = this.props
    return playlistStore.isActive(item.id)
  }

  get checked() {
    const { playlistStore, item } = this.props
    return !!playlistStore.items.find(i => i.id === item.id)
  }

  get clsName() {
    let name = 'productItem cursor-pointer'
    let highlight = this.props.packStore.highlight && !this.props.item.owned

    if (this.active) {
      name += ' productActive'
    } else if (this.checked || highlight) {
      name += ' productChecked'
    } else {
      name += ' productStrip'
    }
    return name
  }

  get waveformPendingColor() {
    return this.active ? '#272B2D' : null
  }

  get loggedIn() {
    return this.props.authStore.isLoggedIn
  }

  get canBuy() {
    const { points, owned } = this.props.item

    if (owned) return false
    if (points === null) return false

    return (points === 0 || this.loggedIn)
  }

  canBuyForMoney = (item) => {
    const { packStore } = this.props

    if (item.owned) return false
    if (this.loggedIn && (packStore.pointsLeft === null)) return false

    return (item.points === null && item.product_id && item.product_id > 0)
  }

  render() {
    const { item, removeLabelTag, collectionId } = this.props
    const notLoggedAndManyPoints = !this.loggedIn && (item.points || 0) > 0

    return (
      <div
        onClick={this.play}
        className={`flex items-center first:border-t border-b border-gray-11 min-h-fit ${this.active ? 'bg-beige-1' : 'hover:bg-gray-15'}`}
      >
        <div
          className={`hidden lg:flex justify-center items-center ${this.props.coverVisible ? 'w-[5%]' : 'lg:w-[calc(5%+60px)] 2xl:w-[calc(5%+60px)]'}`}
        >
          {
            this.props.checkBoxVisible && (
              <label>
                <ItemCheckbox
                  onChange={this.toggleChecked}
                  checked={this.checked}
                  invertedColors={this.active}
                />
              </label>
            )
          }
        </div>

        <Cover
          cover={this.cover}
          onClick={this.redirectToProduct.bind(this)}
          item={item}
        />

        <div className='flex pt-2.5 lg:pt-0 pl-2 pr-4 lg:pr-0 justify-between grow flex-wrap lg:w-[calc(100%-5%-60px)] 2xl:w-[calc(100%-5%-60px)]'>
          <Waveform
            pendingColor={this.waveformPendingColor}
            encodedData={item.encodedData}
            active={item.active}
            key={item.id}
            className='flex-1 pr-5 lg:w-[23%] lg:flex-none lg:order-1 lg:px-3 lg:py-2.5'
          />

          <div className={`hidden items-center order-2 text-center font-bold lg:flex lg:w-[5%] ${this.active ? 'text-gray-16' : 'text-gray-3'}`}>
            {item.bpm}
          </div>

          <div className='hidden items-center order-3 lg:flex lg:w-[9%] lg:px-0.5'>
            <KeysList labels={item.key} wrap={true} />
          </div>

          <div className='flex items-center gap-3 lg:gap-6 2xl:gap-7 lg:order-4 lg:w-[20%] xl:justify-center'>
            <div className='flex gap-1 items-center lg:order-3'>
              {
                notLoggedAndManyPoints && (
                  <div
                    className={`w-[57px] flex justify-center px-3 py-0.5 rounded-[23px] min-h-[23px] lg:min-h-[28px] ${this.active ? 'text-black' : 'text-gray-3'}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className='flex items-center mr-1 text-xs font-bold'>{item.points}</span>
                    <div className='flex items-center min-w-[19px] max-w-[19px]'>
                      <ProductItemPoint className={`${this.active ? '[&_path]:fill-black' : '[&_path]:fill-gray-3'}`} />
                    </div>
                  </div>
                )
              }
              <div className={(!item.owned && (item.points === null)) ? 'md:w-[57px]' : ''}>
                { (this.canBuy || this.canBuyForMoney(item)) &&
                  <BuyItem
                    item={item}
                    searchPage={this.props.homeOnFiltersClear}
                    invertedColors={this.active}
                  />
                }
              </div>
              {
                item.owned && (
                  <DownloadItem
                    item={item}
                    yellowLabel={item.yellowLabel}
                    invertedColors={this.active}
                  />
                )
              }
            </div>

            <div className='flex items-center lg:order-1'>
              { this.loggedIn &&
                  <FavoriteButton
                    item={item}
                    width='28px'
                    height='28px'
                    stateMode={true}
                    invertedColors={this.active}
                    collectionId={collectionId}
                  />
              }
            </div>

            <div className='flex items-center lg:order-2'>
              { this.loggedIn && <MenuButton
                  itemUuid={item.uuid}
                  invertedColors={this.active}
                  fetchProductItems={this.props.fetchProductItems}
                />
              }
            </div>

          </div>

          <div className='basis-full lg:basis-auto lg:order-1 lg:w-[37%] lg:py-2'>
            <p className={`${this.active ? 'text-black' : 'text-gray-3'} break-all line-clamp-1 lg:pb-1.5`}>{item.name}</p>

            <ProductLabelsList
              homeOnFiltersClear={this.props.homeOnFiltersClear}
              removeLabelTag={removeLabelTag}
              active={this.active}
              className='hidden lg:flex text-xs'
              maxChars={30}
              labels={item.tags}
              showOverflowNumber={true}
              showLabelNumbers={false}
              invertedTextColor={this.active}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ProductItem;
